import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgModalService } from './img-modal.service';
import { Subject, takeUntil } from 'rxjs';
import { ScrollService } from '@app/modules/registration/registration-card/services/scroll.service';
import { imageAnimation } from '@app/shared/constants';

@Component({
  selector: 'img-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './img-modal.component.html',
  styleUrls: ['./img-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [imageAnimation]
})
export class ImgModalComponent implements OnInit, OnDestroy {
  @ViewChild('modalImage') modalImage!: ElementRef<HTMLImageElement>;

  private destroy$ = new Subject<void>();

  isOpen = false;
  imageSrc: string | ArrayBuffer = '';
  imageAlt = 'Image Modal';

  constructor(
    private imgModalService: ImgModalService,
    private cdr: ChangeDetectorRef,
    private scrollService: ScrollService
  ) {}

  ngOnInit() {
    this.imgModalService.modalState$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      if (state.isOpen && !this.isOpen) {
        this.openModal(state);
      } else if (!state.isOpen && this.isOpen) {
        this.closeModal();
      }

      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.scrollService.enableScroll();
  }

  openModal(state: { imageSrc: string | ArrayBuffer; imageAlt?: string }) {
    this.isOpen = true;
    this.imageSrc = state.imageSrc;
    this.imageAlt = state.imageAlt || 'Image Modal';
    this.scrollService.disableScroll();
  }

  closeModal() {
    this.isOpen = false;
    this.scrollService.enableScroll();
    this.imgModalService.closeModal();
  }

  onContentClick(event: MouseEvent) {
    event.stopPropagation();
  }
}
